import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const TrashIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 0a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5ZM1 3a1 1 0 0 0 0 2h1v8a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5h1a1 1 0 1 0 0-2H1Zm3 10V5h8v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z", fill: "currentColor" })));
});
TrashIcon.displayName = 'TrashIcon';
export default TrashIcon;
